// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderConfirmation {
  display: flex;
  gap: 40px 81px;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-left: 30px;
  padding-right: 30px;

}

.orderDetails {
  flex: 1 1;
  max-width: 501px;
  min-width: 240px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 9px -4px #727070;
  height: fit-content;
}
.mainWhiteBox{
  border-radius: 6px;

}

.cardPreview {
  display: flex;
  flex-direction: row !important;
}

.cardInfo {
  flex-direction: column;
  width: auto !important; 
  flex: 1 1;
}

.cardHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between; 
  align-items: center;
  gap: 10px;
  font-size: 25px;
  width: 100%; 
  flex-wrap: nowrap; 
}

.cardTitle {
  line-height: 25px;
  flex-shrink: 1;
}

.cardSubtitle {
  display: block;
  font-size: 16px;
}

.cardValue {
  line-height: 1;
  flex-shrink: 0; 
  white-space: nowrap; 
}

.cardDeliveryInfo {
  margin-top: 9px;
  font-size: 11px;
  font-weight: 400;
}

.helpSection {
  margin-top: 40px;
}

.helpTitle {
  margin-top: 150px !important;
  font-size: 18px;
  line-height: 2;
}

.helpText {
  font-size: 13px;
  line-height: 24px;
  margin-top: 8px;
}

.confirmationBox {
  padding: 13px 17px;
  max-width: 397px;
  min-width: 240px;
  background-color: #fff;
}

.confirmationContent {
  display: flex;
  flex-direction: column;
}

.confirmationHeader {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.confirmationTitle {
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 10px;
  text-align: center;
}

.confirmationMessage {
  font-size: 13px;
  line-height: 24px;
  margin-top: 30px;
}

.actionButtons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 40px;
  width: 363px;
  text-align: center;
}

.primaryButton,
button.primaryButton,
.toHomeAction .primaryButton,
.toHomeAction button.primaryButton {
  border: 1px solid transparent;
  border-radius: 50px;
  width: 100%;
  font-size: 18px !important;
  padding: 11px 36px;
  cursor: pointer;
  color: #fff !important;
  transition: all 0.3s ease;
}

.primaryButton:hover,
button.primaryButton:hover,
.toHomeAction .primaryButton:hover,
.toHomeAction button.primaryButton:hover {
  background-color: #fff !important;
  border-color: var(--main-color, "black") !important;
  color: var(--main-color,"black") !important;
}

.secondaryButton,
button.secondaryButton {
  border: none;
  border-radius: 50px;
  width: 100%;
  font-size: 18px !important;
  padding: 11px 36px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.secondaryButton:hover,
button.secondaryButton:hover {
  background-color: #e0e0e0 !important;
  opacity: 0.9;
}

.payment-card-container {
  overflow: hidden;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 16px;
}
.payment-card-info-horizontal{
  margin-bottom: 0px !important;
}
.payment-card-upper {
  display: flex;
  padding-top: 16px;
  padding-right: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
}
.card-item{}
.payment-card-image-container {
  flex-shrink: 0;
  margin-right: 9px;
  
}

.payment-card-image {
  width: 145px;
  height: auto;
  min-height: 90px;
  border-radius: 4px;
  object-fit: cover;
}

.payment-card-info {
  flex: 1 1;
}

.payment-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.payment-card-title {
  font-size: 25px;
}

.payment-card-subtitle {
  font-size: 15px;
}

.payment-card-value {
  font-size: 26px;
  font-weight: bold;
}

.payment-card-delivery-info {
  font-size: 11px;
  color: #383838;
  margin-top: 8px;
}

.payment-card-footer {
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
  background-color: white;
}

.payment-card-beneficiary-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}

.payment-card-beneficiary-name {
  font-size: 14px;
}

.payment-card-beneficiary-email {
  font-size: 13px;
  color: #666;
}

.btn .primaryButton .payment-card-download-button  {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 50px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  border: none;
}

.payment-card-message {
  background-color: #fff;
}

.payment-card-message-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}

.payment-card-message-content {
  font-size: 13px;
  color: #555;
}

.client-info-header {
  padding: 20px;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 30px auto;
}

.client-info-title {
  font-size: 22px;
  margin-bottom: 15px;
}

.client-info-text {
  font-size: 16px;
  line-height: 1.5;
}

@media (max-width: 991px) {
  .orderConfirmation {
    flex-direction: column;
  }
  .download-button-container {
    justify-content: center !important; 
  }
  .cardPreview {
    margin-top: 20px; 
    flex-direction: column !important; 
    text-align: center !important;
    padding: 12px !important; 
  }
  
  .cardImage {
    margin: 0 auto 20px;
    width: 80% !important; 
    max-width: 300px;
  }
  
  .cardHeader {
    flex-direction: column; 
    align-items: center;
    gap: 5px;
  }
  
  .cardValue {
    margin-top: 10px;
  }
  
  .orderDetails {
    max-width: 100%;
    border-radius: 8px;

  }
  
  .confirmationBox {
    max-width: 100%;
  }
  
  .actionButtons {
    width: 100%;
    align-items: center;
  }
  
  .helpTitle {
    margin-top: 30px !important; 
  }
  
  .primaryButton,
  button.primaryButton,
  .toHomeAction .primaryButton,
  .toHomeAction button.primaryButton {
    width: 100%;
    max-width: 363px;
    margin: 0 auto;
  }
  
  .payment-card-upper {
    flex-direction: column;
  }
  
  .payment-card-image-container {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
    text-align: center;
  }
  
  .payment-card-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .payment-card-value {
    margin-top: 10px;
  }
  
  .payment-card-footer {
    flex-direction: column;
    gap: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/Payment/Payment.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;;EAIE,iCAAiC;EACjC,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,WAAW;AACX;EACE,cAAc;EACd,iBAAiB;;AAEnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;;EAEpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;IAIE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".orderConfirmation {\n  display: flex;\n  gap: 40px 81px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding-left: 30px;\n  padding-right: 30px;\n\n}\n\n.orderDetails {\n  flex: 1;\n  max-width: 501px;\n  min-width: 240px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 0 9px -4px #727070;\n  height: fit-content;\n}\n.mainWhiteBox{\n  border-radius: 6px;\n\n}\n\n.cardPreview {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.cardInfo {\n  flex-direction: column;\n  width: auto !important; \n  flex: 1;\n}\n\n.cardHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; \n  align-items: center;\n  gap: 10px;\n  font-size: 25px;\n  width: 100%; \n  flex-wrap: nowrap; \n}\n\n.cardTitle {\n  line-height: 25px;\n  flex-shrink: 1;\n}\n\n.cardSubtitle {\n  display: block;\n  font-size: 16px;\n}\n\n.cardValue {\n  line-height: 1;\n  flex-shrink: 0; \n  white-space: nowrap; \n}\n\n.cardDeliveryInfo {\n  margin-top: 9px;\n  font-size: 11px;\n  font-weight: 400;\n}\n\n.helpSection {\n  margin-top: 40px;\n}\n\n.helpTitle {\n  margin-top: 150px !important;\n  font-size: 18px;\n  line-height: 2;\n}\n\n.helpText {\n  font-size: 13px;\n  line-height: 24px;\n  margin-top: 8px;\n}\n\n.confirmationBox {\n  padding: 13px 17px;\n  max-width: 397px;\n  min-width: 240px;\n  background-color: #fff;\n}\n\n.confirmationContent {\n  display: flex;\n  flex-direction: column;\n}\n\n.confirmationHeader {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.confirmationTitle {\n  font-size: 18px;\n  line-height: 20px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.confirmationMessage {\n  font-size: 13px;\n  line-height: 24px;\n  margin-top: 30px;\n}\n\n.actionButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 40px;\n  width: 363px;\n  text-align: center;\n}\n\n.primaryButton,\nbutton.primaryButton,\n.toHomeAction .primaryButton,\n.toHomeAction button.primaryButton {\n  border: 1px solid transparent;\n  border-radius: 50px;\n  width: 100%;\n  font-size: 18px !important;\n  padding: 11px 36px;\n  cursor: pointer;\n  color: #fff !important;\n  transition: all 0.3s ease;\n}\n\n.primaryButton:hover,\nbutton.primaryButton:hover,\n.toHomeAction .primaryButton:hover,\n.toHomeAction button.primaryButton:hover {\n  background-color: #fff !important;\n  border-color: var(--main-color, \"black\") !important;\n  color: var(--main-color,\"black\") !important;\n}\n\n.secondaryButton,\nbutton.secondaryButton {\n  border: none;\n  border-radius: 50px;\n  width: 100%;\n  font-size: 18px !important;\n  padding: 11px 36px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.secondaryButton:hover,\nbutton.secondaryButton:hover {\n  background-color: #e0e0e0 !important;\n  opacity: 0.9;\n}\n\n.payment-card-container {\n  overflow: hidden;\n  max-width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-bottom: 16px;\n}\n.payment-card-info-horizontal{\n  margin-bottom: 0px !important;\n}\n.payment-card-upper {\n  display: flex;\n  padding-top: 16px;\n  padding-right: 24px;\n  padding-bottom: 8px;\n  padding-left: 24px;\n}\n.card-item{}\n.payment-card-image-container {\n  flex-shrink: 0;\n  margin-right: 9px;\n  \n}\n\n.payment-card-image {\n  width: 145px;\n  height: auto;\n  min-height: 90px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.payment-card-info {\n  flex: 1;\n}\n\n.payment-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.payment-card-title {\n  font-size: 25px;\n}\n\n.payment-card-subtitle {\n  font-size: 15px;\n}\n\n.payment-card-value {\n  font-size: 26px;\n  font-weight: bold;\n}\n\n.payment-card-delivery-info {\n  font-size: 11px;\n  color: #383838;\n  margin-top: 8px;\n}\n\n.payment-card-footer {\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 24px;\n  background-color: white;\n}\n\n.payment-card-beneficiary-title {\n  font-size: 14px;\n  margin: 0 0 8px 0;\n}\n\n.payment-card-beneficiary-name {\n  font-size: 14px;\n}\n\n.payment-card-beneficiary-email {\n  font-size: 13px;\n  color: #666;\n}\n\n.btn .primaryButton .payment-card-download-button  {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 50px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  border: none;\n}\n\n.payment-card-message {\n  background-color: #fff;\n}\n\n.payment-card-message-title {\n  font-size: 14px;\n  margin: 0 0 8px 0;\n}\n\n.payment-card-message-content {\n  font-size: 13px;\n  color: #555;\n}\n\n.client-info-header {\n  padding: 20px;\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 30px auto;\n}\n\n.client-info-title {\n  font-size: 22px;\n  margin-bottom: 15px;\n}\n\n.client-info-text {\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n@media (max-width: 991px) {\n  .orderConfirmation {\n    flex-direction: column;\n  }\n  .download-button-container {\n    justify-content: center !important; \n  }\n  .cardPreview {\n    margin-top: 20px; \n    flex-direction: column !important; \n    text-align: center !important;\n    padding: 12px !important; \n  }\n  \n  .cardImage {\n    margin: 0 auto 20px;\n    width: 80% !important; \n    max-width: 300px;\n  }\n  \n  .cardHeader {\n    flex-direction: column; \n    align-items: center;\n    gap: 5px;\n  }\n  \n  .cardValue {\n    margin-top: 10px;\n  }\n  \n  .orderDetails {\n    max-width: 100%;\n    border-radius: 8px;\n\n  }\n  \n  .confirmationBox {\n    max-width: 100%;\n  }\n  \n  .actionButtons {\n    width: 100%;\n    align-items: center;\n  }\n  \n  .helpTitle {\n    margin-top: 30px !important; \n  }\n  \n  .primaryButton,\n  button.primaryButton,\n  .toHomeAction .primaryButton,\n  .toHomeAction button.primaryButton {\n    width: 100%;\n    max-width: 363px;\n    margin: 0 auto;\n  }\n  \n  .payment-card-upper {\n    flex-direction: column;\n  }\n  \n  .payment-card-image-container {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 15px;\n    text-align: center;\n  }\n  \n  .payment-card-header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .payment-card-value {\n    margin-top: 10px;\n  }\n  \n  .payment-card-footer {\n    flex-direction: column;\n    gap: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
